<template>
  <div id="activationCode">
    <!-- 搜索 -->
    <div class="flex justify-end align-center" style="height: 32px;">
          <el-select @change="select_time" v-model="time" placeholder="筛选激活码时长">
            <el-option label="全部" value="1"></el-option>
            <el-option label="三个月" value="7776000"></el-option>
            <el-option label="一年" value="31536000"></el-option>
            <el-option label="两年" value="63072000"></el-option>
            <el-option label="三年" value="94608000"></el-option>
            <el-option label="永久" value="3153600000"></el-option>
          </el-select>
      <el-button @click='dialogVisible=true' style='background-color:#1BADE8;color: #FFFFFF;height: 32px;padding: 0 20px;margin-left: 16px;'>添加</el-button>
    </div>
    <!-- 分界线 -->
    <div class="" style="height: 10px;background-color: #F5F6FA;width: 100%;margin-top: 16px;margin-bottom: 24px;">
    </div>
    <div class="flex flex-direction justify-between" style="min-height: 780px;">
      <div class="">
        <!-- 表格 -->
        <el-table :data="tableData" stripe style="width: 100%">
          <el-table-column type="index" align="center" label="序号" width="50">
          </el-table-column>
          <el-table-column prop="ip" align="center" label="使用IP">
          </el-table-column>
          <el-table-column prop="code" align="center" width="320" label="激活码">
          </el-table-column>
          <el-table-column prop="time" align="center" label="服务周期">
            <template slot-scope="scope">
              <span>{{ scope.row.time | cycle }}</span>
            </template>
          </el-table-column>
          <el-table-column prop="state" align="center" label="状态">
          </el-table-column>
          <el-table-column prop="use_time" align="center" label="使用时间">
          </el-table-column>
          <el-table-column prop="version_number" align="center" label="使用版本">
          </el-table-column>
          <el-table-column prop="create_time"  align="center" label="生成时间">
          </el-table-column>
          <el-table-column prop="remark" align="center" label="备注">
            <template slot-scope="scope">
              <el-tooltip class="item" effect="dark" :content="'备注' | remark_" placement="left">
                <span style="overflow: hidden;text-overflow: ellipsis;display: -webkit-box;-webkit-line-clamp: 2;-webkit-box-orient: vertical;">
                  {{ scope.row.remark | remark_ }}
                </span>
              </el-tooltip>
            </template>
          </el-table-column>
        </el-table>
      </div>
      <!-- 分页 -->
      <el-pagination id='pagebox' style="margin-top: 30px;text-align: center;" background
        @current-change="handleCurrentChange" :current-page="tablePage" :page-size='tableLimit'
        :page-sizes="[100, 200, 300, 400]" layout="total, prev, pager, next, jumper" :total="tableCount">
      </el-pagination>
    </div>

    <!-- 添加卡密 -->
    <el-dialog
      title="添加卡密"
      :visible.sync="dialogVisible"

      id='addKm'
      >
      <p style="text-align: left;font-weight: 700;font-size: 20px;color: #000000;margin-bottom: 16px;">生成卡密条数</p>
      <div class="list flex align-center justify-between">
        <div class="" style="position: relative;" @click="chooseNum(item)" v-for="(item,index) in list" :key='index'>
          <div class="flex align-center justify-center list_tip" :class="current==item?'active_':''">
            <span style="color: #000000;font-size: 18px;">{{item}}条</span>
            <i class="iconfont icon-youxiajiaoxuanzhong" style="position: absolute;right: 0;bottom: 0;display: none;" :class="current==item?'isShow':''"></i>
          </div>
        </div>
      </div>

      <p style="text-align: left;font-weight: 700;font-size: 20px;color: #000000;margin-bottom: 16px;margin-top: 16px;">生成卡密时长</p>
      <!-- justify-between -->
      <div class="list flex flex-wrap align-center ">
        <div class="" style="position: relative;" @click="chooseNum_(item.value)" v-for="(item,index) in list_" :key='index'>
          <div class="flex align-center justify-center list_tip_" :class="current_==item.value?'active_':''">
            <span style="color: #000000;font-size: 18px;">{{item.label}}</span>
            <i class="iconfont icon-youxiajiaoxuanzhong" style="position: absolute;right: 24px;bottom: 16px;display: none;" :class="current_==item.value?'isShow':''"></i>
          </div>
        </div>
      </div>

      <div class="flex flex-direction justify-start">
        <p style="text-align: left;font-size: 20px;color: #000000;font-weight: 700;margin-top: 40px;margin-bottom: 24px;">自定义数量</p>
          <el-input @change="choose_num" type="number" style="width: 180px;" placeholder="请输入数量" v-model.number="total_">
          </el-input>
      </div>

      <div class="flex flex-direction justify-start">
        <p style="text-align: left;font-size: 20px;color: #000000;font-weight: 700;margin-top: 40px;margin-bottom: 24px;">备注</p>
        <el-input
          type="textarea"
          :rows="2"
          placeholder="请输入备注信息"
          v-model="addJhm.remark">
        </el-input>
      </div>

      <span slot="footer" class="dialog-footer">
        <el-button style="height: 32px;background: #F5F6F7;border-radius: 2px;padding: 9px 20px;" @click="dialogVisible = false">取 消</el-button>
        <el-button style="height: 32px;background: #1BADE8;border-radius: 2px;padding: 9px 20px;color: #FFFFFF;" type="primary" @click="userCodeMake">确 定</el-button>
      </span>
    </el-dialog>
  </div>

</template>

<script>
  export default {
    name: 'activationCode',
    created() {
      this.getTable()
    },
    data() {
      return {
        ruleForm: {},
        rules: {},
        /* 获取表格数据发送参数 */
        sendData: {
          act: 'userCode',
          page: 1,
          limit: 15
        },
        time:'',
        /* 渲染页面参数 */
        tablePage: 1, //表格--当前页
        tableLimit: 10, //表格--当前页数据条数尺寸
        tableCount: 10, //表格--数据总条数
        tableData: [], //表格--数据列表

        dialogVisible:false,//添加卡密弹框
        list:['50','100','500','1000'],
        list_:[
          {value:'0',label:'七天'},
          {value:'1',label:'十五天'},
          {value:'2',label:'一个月'},
          {value:'3',label:'三个月'},
          {value:'4',label:'一年'},
          {value:'5',label:'两年'},
          {value:'6',label:'三年'},
          {value:'7',label:'永久'}
        ],
        current:50,//初始选择
        current_:0,
        total_:'',//生成卡密输入框条数

        /* 激活码生成请求参数 */
        addJhm:{
          act:'userCodeMake',
          total:'50',
          time:'604800',
          remark:''
        }
      }
    },
    filters:{
      /* 服务周期*/
      cycle(value){
        if(value=='604800') return '七天'
        if(value=='1296000') return '十五天'
        if(value=='2592000') return '一个月'
        if(value=='7776000') return '三个月'
        if(value=='31536000') return "一年"
        if(value=='63072000') return "两年"
        if(value=='94608000') return "三年"
        if(value=='3153600000') return "永久"
      },
      remark_(value){
        return value
      }
    },
    methods: {
      /******************* 获取数据列表 */
      getTable() {
        this.$api.dataList.userTable(this.sendData).then(res => {
          if (res.code == '1') {
            this.tablePage = res.data.page
            this.tableLimit = res.data.limit
            this.tableCount = res.data.count
            this.tableData = res.data.list
          }
        })
      },
      /******************* 切换页面  */
      handleCurrentChange(val) {
        this.sendData.page = val
        this.getTable()
      },
      /******************************选择卡密条数 */
      chooseNum(num){
        this.current=num
        this.addJhm.total=num
        this.total_='' //输入框制空
      },
      choose_num(){
        this.current=''
        this.addJhm.total=this.total_
      },

      chooseNum_(str){
        console.log(str)
        this.current_=str
        let data_=['604800','1296000','2592000','7776000','31536000','63072000','94608000','3153600000']
        this.addJhm.time=data_[str]
        // console.log(this.addJhm.time)
      },
      /* 生成卡密 */
      userCodeMake(){
        let that= this
        if(this.total_&&this.total_<0){
          that.$message({
            message: "自定义数量不能为负数",
            type: 'error'
          })
          return false
        }
        if(this.total_){
          that.addJhm.total=that.total_
        }
        // console.log(this.addJhm)
        this.$api.dataList.userTable(this.addJhm).then(res=>{
          if(res.code=='1'){
            that.$message({
              message: res.info,
              type: 'success'
            })
            that.dialogVisible=false
            that.sendData.page=1
            that.getTable()
          }else{
            that.$message({
              message: res.info,
              type: 'error'
            })
          }
        })
      },

      select_time(e){
        console.log(e)
        this.sendData.time=e
        this.sendData.page=1
        if(e=='1'){
          delete this.sendData.time
        }
        this.getTable()
      },
    }
  }
</script>

<style>
  /* 引入阿里icon */
  @import '//at.alicdn.com/t/font_2704137_sjcazhxcqwo.css';
  #activationCode {
    background-color: #FFFFFF;
    padding: 24px;
    position: relative;
    border-radius: 6px;
  }

  #activationCode #pagebox {}

  /****************************/
  /* 备注 */
  #bigBox .el-dialog,
  #smallBox .el-dialog {
    border-radius: 8px;
  }

  #bigBox .el-dialog__header,
  #smallBox .el-dialog__header {
    display: none;
  }

  #bigBox .el-dialog__body {
    padding: 24px;
    min-height: 400px;
  }

  #bigBox .titlep {
    color: #000;
    font-size: 14px;
    text-align: left;
    font-weight: 700;
  }

  #bigBox .btn_ {
    height: 32px;
    color: #FFFFFF;
    padding: 0 20px;
    background-color: #1BADE8;
  }

  #smallBox .el-dialog__title {
    color: #000000;
    font-weight: 700;
    font-size: 14px;
  }

  #smallBox .el-dialog {
    padding: 24px;
  }

  #smallBox .el-dialog__body {
    padding: 0;
  }

  #form .el-form-item__content {
    margin-left: 0 !important;
  }

  #form .el-form-item__label {
    text-align: left;
  }

  #form .el-input__inner {
    background-color: #F5F6FA !important;
    border: none !important;
  }

  #activationCode #addKm .el-dialog{
    border-radius: 8px;
    padding: 20px;
    width: 660px;
  }
  #activationCode #addKm .el-dialog__header{
    text-align: left;
    color: #000000;
    font-size: 14px;
    padding: 0;
    border-bottom: 1px solid #EEEEEE;
    padding-bottom: 16px;
  }

  #activationCode #addKm .el-input-group__append{
    background-color: #FFFFFF;
  }
  #activationCode #addKm .el-input__inner{
    /* border-right: none; */
  }

  .list_tip{
    width: 120px;
    height: 80px;
    border-radius: 4px;
    border: 1px solid #D9D9D9;
    cursor: pointer;
  }
  .list_tip:hover{
    background: rgba(27, 173, 232, 0.1) !important;
    border: 1px solid #1BADE8 !important;
  }

  .list_tip_{
    width: 160px;
    height: 70px;
    margin-bottom: 16px;
    border-radius: 4px;
    border: 1px solid #D9D9D9;
    cursor: pointer;
    box-sizing: border-box;
    margin-right: 24px;
  }
  .list_tip_:hover{
    background: rgba(27, 173, 232, 0.1) !important;
    border: 1px solid #1BADE8 !important;
  }


  .active_{
    background: rgba(27, 173, 232, 0.1) !important;
    border: 1px solid #1BADE8 !important;
  }
  .isShow{
    color: #1BADE8 !important;
    display: block !important;
  }


</style>



// WEBPACK FOOTER //
// src/components/activationCode.vue